//@ts-nocheck
import { MerchantAddFormAuthorizationSection, MerchantAddFormLimitSection } from "../../components"
import { Button } from "../../../../atoms/Button";
import { useEffect, useState } from "react";
import { useMerchantUpdate } from "../../../../../hooks";
import { useSetSnackBar } from "../../../../../store/Snackbar.state";

import {
    Box,
    Stack,
    Typography,
    useTheme,
    useMediaQuery,
    Switch,
    FormControlLabel,
    Card,
    CardHeader,
    CardContent
} from "@mui/material";

export interface MerchantSpecialSettingsTabProps {
    merchant: any;
    control: any;
    reset: any;
    setValue: any;
    getValues: any;

    workplaceType: any;

    allData: any;
    setAllData: any;

    isRestrictedLink: boolean;
    isLinkCreationActive: boolean;
    isNonSecureActive: boolean;
    linkExpireInMinutes: number;
    linkQuantity: number;
    isUnlimitedLink: boolean;
    isCepPosCardPayments: boolean;
    isUsageFee: boolean;
}

export const MerchantSpecialSettingsTab = (props: MerchantSpecialSettingsTabProps) => {
    const isDesktop = useMediaQuery(useTheme().breakpoints.up("md"));
    const { mutate: updateMerchant, isLoading: updateLoading } =
        useMerchantUpdate();

    const [formState, setFormState] = useState<MerchantAddFormAuthorizationSectionFormStates>({
        isUnlimitedLinkActive: false,
        isLinkCreationActive: false,
        isNonSecureActive: false,
        isRestrictedLink: false,
        linkExpireInMinutes: 0,
        linkQuantity: 1
    });

    const [formStateLimit, setFormStateLimit] = useState<MerchantAddFormLimitSectionFormStates>({
        hasGiroRestriction: false,
        hasAutomaticGiroLimitIncrease: false,
        commercialFlag: false,
        giroLimit: 0,
        corporateFlag: false
    });

    const setSnackbar = useSetSnackBar();

    const [isFirstLoadFinshed, setIsFirstLoadFinshed] = useState(false);

    const [hasManualInstallmentManagement, setHasManualInstallmentManagement] = useState(true);

    useEffect(() => {

        if (!isFirstLoadFinshed) {

            setFormState({
                isUnlimitedLinkActive: props.allData.isUnlimitedLink ?? false,
                isLinkCreationActive: props.allData.linkPaymentActive ?? false,
                isNonSecureActive: props.allData.nonSecure ?? false,
                linkExpireInMinutes: props.allData.linkExpireInMinutes ?? 0,
                linkQuantity: props.allData.linkQuantity ?? 1,
                isRestrictedLink: props.allData.restrictedLink
            });

            setFormStateLimit({
                hasGiroRestriction: props.allData.hasGiroRestriction ?? false,
                hasAutomaticGiroLimitIncrease: props.allData.hasAutomaticGiroLimitIncrease ?? false,
                commercialFlag: props.allData.commercialFlag ?? false,
                giroLimit: props.allData.giroLimit ?? 0,
                corporateFlag: props.allData.corporateFlag ?? false
            });

            setHasManualInstallmentManagement(props.allData.hasManualInstallmentManagement);
            setIsFirstLoadFinshed(true);
        }

    }, [props.merchant]);

    const [isCepPosCardPaymentsState, setIsCepPosCardPaymentsState] = useState(props.allData.isCepPosCardPayments);
    const [isUsageFeeState, setIsUsageFeeState] = useState(props.allData.isUsageFee);

    const onUpdate = () => {

        let request = {
            giroLimit: props.getValues('giroLimit'),
            // linkExpireInMinutes: props.getValues('linkExpireInMinutes'),
            linkQuantity: props.getValues('linkQuantity'),
            linkExpireInMinutes: props.getValues('linkExpireInMinutes'),
            nonSecure: formState.isNonSecureActive,
            isOnlyTabUpdate: true,
            hasAutomaticGiroLimitIncrease: formStateLimit.hasAutomaticGiroLimitIncrease,
            hasGiroRestriction: formStateLimit.hasGiroRestriction,
            linkPaymentActive: formState.isLinkCreationActive,
            isUnlimitedLink: formState.isUnlimitedLinkActive,
            merchantStatusType: props.merchant.merchantStatusType,
            restrictedLink: formState.isRestrictedLink,
            hasManualInstallmentManagement: hasManualInstallmentManagement,
            isCepPosCardPayments: isCepPosCardPaymentsState,
            isUsageFee: isUsageFeeState
        }

        updateMerchant(
            {
                ...request,
                id: props.allData?.id || 0,
                merchantId: props.merchant?.merchantId || props.allData?.merchantId || 0,
            },
            {
                onSuccess(data) {
                    if (data.isSuccess) {
                        props.setAllData({
                            ...props.allData,
                            ...request
                        });
                        
                        setSnackbar({
                            severity: "success",
                            isOpen: true,
                            description: data.message,
                        });
                    } else {
                        setSnackbar({
                            severity: "error",
                            isOpen: true,
                            description: data.message,
                        });
                    }
                },
                onError: (error) => {
                    setSnackbar({
                        severity: "error",
                        isOpen: true,
                        description: "İşlem sırasında bir hata oluştu",
                    });
                },
            }
        )
    }

    return (
        <Box p={isDesktop ? 3 : 2}>
            <Stack spacing={3}>
                <MerchantAddFormLimitSection
                    merchant={props.merchant}
                    control={props.control}
                    formState={formStateLimit}
                    setFormState={setFormStateLimit}
                    setValue={props.setValue}
                    workplaceType={props.workplaceType}
                />
                <MerchantAddFormAuthorizationSection
                    control={props.control}
                    merchant={props.merchant}
                    formState={formState}
                    setFormState={setFormState}
                    hasManualInstallmentManagement={hasManualInstallmentManagement}
                    setHasManualInstallmentManagement={setHasManualInstallmentManagement}
                />

                <Card variant="outlined">
                    <CardHeader title="CepPOS Ayarları" />
                    <CardContent>
                        <Box>
                            <FormControlLabel
                                control={<Switch checked={isCepPosCardPaymentsState} onChange={(e) => setIsCepPosCardPaymentsState(e.target.checked)} />}
                                label="CepPOS Kartlı İşlem"
                            />
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 4 }}>
                                NFC özellikli telefonların POS cihazı olarak kullanılmasını aktive eder.
                            </Typography>
                        </Box>
                    </CardContent>
                </Card>

                <Card variant="outlined">
                    <CardHeader title="POS Ayarları" />
                    <CardContent>
                        <Box>
                            <FormControlLabel
                                control={<Switch checked={isUsageFeeState} onChange={(e) => setIsUsageFeeState(e.target.checked)} />}
                                label="POS Bedeli Kullanımı"
                            />
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', pl: 4 }}>
                                POS cihazı kullanım bedelinin aktif edilmesini sağlar.
                            </Typography>
                        </Box>
                    </CardContent>
                </Card>

                <Stack direction="row" justifyContent="flex-end" pt={2}>
                    <Button
                        variant="contained"
                        text="Ayarları Kaydet"
                        onClick={onUpdate}
                    />
                </Stack>
            </Stack>
        </Box>
    );
}